import { Helmet } from 'react-helmet';
import CustomLogin from 'pages/Custom/Login';
import HiperdinoLogin from 'pages/Custom/Hiperdino/Login';
import HiperdinoLogo from 'assets/custom/hiperdino/logo.svg';

const useCustomCompany = () => {
  const subdomain = window.location.hostname.split('.')[0];

  const isHiperdino = window.location.hostname.includes('dinosol');
  const isApp = subdomain === 'app';
  const isPre = subdomain === 'pre';
  const isDev = subdomain === 'dev';
  const isLocalhost = subdomain === 'localhost';

  if (isHiperdino) {
    const HelmetComponent = (
      <Helmet>
        <title>HiperDino Conecta</title>
        <link id="favicon" rel="icon" href="/hiperdino-favicon.ico" />
      </Helmet>
    );

    return {
      company: 'hiperdino',
      showForgotButton: false,
      LoginComponent: HiperdinoLogin,
      CustomHomeLogo: HiperdinoLogo,
      HelmetComponent,
      //...rest of front configs like logo url or something
    };
  }

  if (!isApp && !isPre && !isDev && !isLocalhost) {
    const company = window.location.hostname.split('.')[0];
    return {
      company,
      LoginComponent: CustomLogin,
      showForgotButton: true,
    };
  }

  return { company: 'default', showForgotButton: true };
};

export default useCustomCompany;
